// extracted by css-extract-rspack-plugin
export default {"gettingStartedDialog":"GettingStartedDialog-module__gettingStartedDialog__gggfCC3"};